import React, { Component } from 'react'; 
import BLIFrame from './BLIFrame'; 
class App extends Component {
  render() {
    return (
      <BLIFrame/>
    );
  }
}

export default App;
